import {Grid,} from "@mui/material";
import React from "react";

import { withTranslation } from 'react-i18next';
import i18n from "../i18n";

const FooterComponent = ( props ) => {
    const {t} = props;
    const currentLang = i18n.language

    return (
        <div className={'contentsDiv'}>
            <Grid container className={'footerToolbar'} spacing={0} alignItems={'baseline'}>
                <Grid
                    size={{
                        xs: 12,
                        sm: 4,
                        md: 3
                    }}>
                    <a href={'https://nuorisotilastot.fi/wp-content/uploads/2025/01/2025_01_07_Tietosuojailmoitus_nuodo.pdf'} target='_blank' rel="noopener noreferrer" className={'link-data-privacy'}>
                        {t('footer.privacy_statement')}
                    </a>
                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 4,
                        md: 3
                    }}>
                    <a href={'https://nuorisotilastot.fi/2350/uncategorized/nuodo-info/'} target='_blank' rel="noopener noreferrer" className={'link-accessibility'}>
                        {t('footer.accessibility_statement')}
                    </a>

                </Grid>
                <Grid
                    size={{
                        xs: 12,
                        sm: 4,
                        md: 3
                    }}>
                    <div className={'copyright'}>© {t('common.application_owner')} {new Date().getFullYear()}</div>
                </Grid>
                <Grid
                    className={'footer-logo'}
                    size={{
                        xs: 12,
                        sm: 12,
                        md: 3
                    }}>
                    <img
                        src={process.env.PUBLIC_URL + (currentLang === 'fi' ? '/media/images/LVV_logo-suomi.png' : '/media/images/LVV_logo-ruotsi.png')}
                        alt={t('common.youth_work')} />
                </Grid>
            </Grid>
        </div>
    );
}
const Footer = withTranslation()(FooterComponent);
export {Footer};